export default function Hero() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50">
      <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse 70% 60% at 80% 40%, oklch(0.52 0.22 25 / 0.06), transparent 60%), radial-gradient(ellipse 50% 50% at 20% 70%, oklch(0.66 0.19 78 / 0.05), transparent 60%)',
      }}></div>

      <div className="relative w-full px-4 md:px-6 lg:px-12 pt-[72px]">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16 max-w-[1280px] mx-auto">
          <div className="flex-1 w-full text-center lg:text-left pt-6 md:pt-10">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full whitespace-nowrap">
              <i className="ri-fire-line"></i>
              全网最全黑料汇总平台
            </span>

            <h1 className="mt-5 font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight">
              911吃瓜网
              <span className="block text-2xl md:text-3xl lg:text-4xl text-foreground-700 mt-2">
                明星网红黑料一网打尽
              </span>
            </h1>

            <p className="mt-3 text-base md:text-lg text-primary-600 font-heading">
              内幕曝光 · 负面新闻 · 黑料合集 · 吃瓜第一线
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              911吃瓜网是全网最全面的黑料汇总平台，专注明星网红内幕曝光与负面新闻整合。
              每日更新最新吃瓜内容，覆盖娱乐圈、网红圈、商业圈等多领域黑料，
              为吃瓜群众提供第一手猛料资讯。匿名投稿通道保障爆料人安全，让真相不再沉默。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center bg-accent-100 text-accent-700 rounded-full">
                  <i className="ri-refresh-line text-sm"></i>
                </span>
                <span className="text-sm text-foreground-600 whitespace-nowrap">每日更新热点</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center bg-accent-100 text-accent-700 rounded-full">
                  <i className="ri-shield-check-line text-sm"></i>
                </span>
                <span className="text-sm text-foreground-600 whitespace-nowrap">全网独家猛料</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center bg-accent-100 text-accent-700 rounded-full">
                  <i className="ri-lock-line text-sm"></i>
                </span>
                <span className="text-sm text-foreground-600 whitespace-nowrap">匿名安全投稿</span>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => handleNavClick('#topics')}
                className="px-8 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer border-0"
              >
                <i className="ri-arrow-right-line mr-1.5"></i>
                立即吃瓜
              </button>
              <button
                onClick={() => handleNavClick('#contact')}
                className="px-8 py-3 border-2 border-secondary-300 text-foreground-700 font-medium text-sm rounded-full hover:border-primary-400 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer bg-transparent"
              >
                <i className="ri-send-plane-line mr-1.5"></i>
                我要爆料
              </button>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-secondary-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20artistic%20composition%20with%20abstract%20geometric%20shapes%20in%20deep%20crimson%20red%20and%20warm%20amber%20tones%2C%20layered%20newspaper-like%20textures%20with%20motion%20blur%20effects%2C%20bold%20contrast%20between%20light%20and%20shadow%2C%20editorial%20design%20aesthetic%20with%20striking%20visual%20impact%2C%20dark%20warm%20background%20with%20radiant%20highlights%2C%20cinematic%20color%20grading%2C%20no%20text%20or%20letters&width=960&height=720&seq=hero-911-main&orientation=landscape"
                alt="911吃瓜网 - 全网黑料汇总平台主视觉"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) {
                    target.parentElement.style.display = 'none';
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}